import React from 'react';
import {Outlet, NavLink, useNavigate} from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import {FiFolder, FiLogOut, FiSettings, FiBriefcase, FiUsers} from 'react-icons/fi';
import {useAuth} from '../contexts/AuthContext';

const MainLayout = () => {
  const {logout, activeOrg} = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login', {replace: true});
    } catch (err) {
      console.error("Logout failed:", err);
    }
  };

  const navItems = [
    {to: '/projects', icon: FiFolder, label: 'Projects'},
    {to: '/team', icon: FiUsers, label: 'Team Members'},
    {to: '/organizations', icon: FiBriefcase, label: 'Organization'},
  ];

  return (
    <div className="flex h-screen w-full bg-rutabaga-bg overflow-hidden font-sans">
      <aside className="w-64 bg-white border-r border-gray-200 flex flex-col justify-between shadow-sm z-20">
        <div>
          <div className="p-6 flex items-center gap-3 border-b border-gray-50">
            <div className="w-10 h-10 bg-rutabaga-pink rounded-md flex items-center justify-center text-white font-black text-2xl shadow-lg shadow-rutabaga-pink/20 shrink-0">
              R
            </div>
            <div className="flex flex-col overflow-hidden">
              <span className="font-bold text-rutabaga-dark leading-none truncate">
                {activeOrg?.name || 'Rutabaga'}
              </span>
              <span className="text-[10px] font-black text-rutabaga-pink uppercase tracking-widest mt-1">
                Research Lab
              </span>
            </div>
          </div>
          <nav className="p-4 space-y-1">
            {navItems.map((item) => (
              <NavLink 
                key={item.to} 
                to={item.to} 
                className={({isActive}) => `
                  flex items-center gap-3 px-4 py-3 rounded-md transition-all duration-200
                  ${isActive ? 'bg-rutabaga-pink/5 text-rutabaga-pink font-bold' : 'text-gray-500 hover:bg-gray-50 hover:text-rutabaga-dark'}
                `}
              >
                <SafeIcon icon={item.icon} className="text-lg" />
                <span className="text-sm">{item.label}</span>
              </NavLink>
            ))}
          </nav>
        </div>
        <div className="p-4 border-t border-gray-100 space-y-1">
          <button className="w-full flex items-center gap-3 px-4 py-3 rounded-md text-gray-500 hover:bg-gray-50 hover:text-rutabaga-dark transition-all text-left text-sm font-medium">
            <SafeIcon icon={FiSettings} className="text-lg" />
            <span>Settings</span>
          </button>
          <button 
            onClick={handleLogout}
            className="w-full flex items-center gap-3 px-4 py-3 rounded-md text-gray-500 hover:bg-red-50 hover:text-red-600 transition-all text-left text-sm font-medium"
          >
            <SafeIcon icon={FiLogOut} className="text-lg" />
            <span>Log out</span>
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-y-auto relative p-8">
        <Outlet />
      </main>
    </div>
  );
};

export default MainLayout;